define('modules/editor/views/element_view_factory',['require','exports','module','./elements/text','./elements/form','./elements/form_button','./elements/button','./elements/video','./elements/image','./elements/html','./elements/social','./elements/popup'],function(require, exports, module) {
  //An element view factory
  var ModelViewMappings = [
    {
      name: "element:text",
      view: require("./elements/text")
    },
    {
      name: "element:form",
      view: require("./elements/form")
    },
    {
      name: "element:form:button",
      view: require("./elements/form_button")
    },
    {
      name: "element:button",
      view: require("./elements/button")
    },
    {
      name: "element:video",
      view: require("./elements/video")
    },
    {
      name: "element:image",
      view: require("./elements/image")
    },
    /*{
      name: "element:area",
      view: require("./elements/area")
    },*/
    {
      name: "element:html",
      view: require("./elements/html")
    },
    {
      name: "element:social",
      view: require("./elements/social")
    },
    {
      name: "element:popup",
      view: require("./elements/popup")
    }
  ];

  module.exports = function(options){
    var viewConstructor = _.findWhere(ModelViewMappings, { name: options.model.name }).view;
    return new viewConstructor(options);
  };
});

